export default __webpack_public_path__ + "static/media/covid.557a62be.jpg";